import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import some from 'lodash/some';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import every from 'lodash/every';
import React from 'react';
import arrayTreeFilter from 'array-tree-filter';
import classnames from 'classnames';
import CSSMotion from 'rc-motion';
import Checkbox from '../checkbox';
import MenuItem from './MenuItem';
import { getElementStyle, isIncludeArray } from './utils';

var Menus = /*#__PURE__*/function (_React$Component) {
  _inherits(Menus, _React$Component);

  var _super = _createSuper(Menus);

  function Menus(props) {
    var _this;

    _classCallCheck(this, Menus);

    _this = _super.call(this, props);
    _this.menus = {};
    _this.menuItems = {};

    _this.saveMenuWrap = function (menuWrap) {
      _this.menuWrap = menuWrap;
    };

    _this.saveMenus = function (menuIndex) {
      return function (menus) {
        _this.menus[menuIndex] = menus;
      };
    };

    _this.saveMenuItems = function (index) {
      return function (node) {
        _this.menuItems[index] = node;
      };
    };

    _this.handleMenuScroll = function (menuIndex) {
      return function () {
        var _a, _b;

        var menuScrollOpen = _this.state.menuScrollOpen;

        if (menuScrollOpen) {
          // 当前menu滚动时，取消当前选中项高亮，隐藏子级
          var activeValue = _this.props.activeValue.slice(0, menuIndex);

          (_b = (_a = _this.props).onActiveValueSet) === null || _b === void 0 ? void 0 : _b.call(_a, activeValue);
        }
      };
    };

    _this.onShowActive = function () {
      _this.scrollActiveItemToView();

      window.setTimeout(function () {
        _this.setMenuPosition();

        window.setTimeout(function () {
          _this.handleMenuScrollChange(true);
        }, 0);
      }, 0);
    };

    _this.onShowEnd = function () {
      _this.handleMenuScrollChange(false);
    };

    _this.state = {
      // 默认关闭对menu scroll事件的监听，待scrollActiveItemToView完成后开启
      menuScrollOpen: false
    };
    return _this;
  }

  _createClass(Menus, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!isEqual(prevProps.activeValue, this.props.activeValue) || prevProps.options !== this.props.options) {
        this.setMenuPosition();
      }
    }
  }, {
    key: "isStatusOption",
    value: function isStatusOption() {
      var statusValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var option = arguments.length > 1 ? arguments[1] : undefined;
      var menuIndex = arguments.length > 2 ? arguments[2] : undefined;
      return statusValue[menuIndex] === option[this.getFieldName('value')];
    }
  }, {
    key: "getFieldName",
    value: function getFieldName(name) {
      var _this$props = this.props,
          fieldNames = _this$props.fieldNames,
          defaultFieldNames = _this$props.defaultFieldNames; // 防止只设置单个属性的名字

      return fieldNames[name] || defaultFieldNames[name];
    }
  }, {
    key: "getOption",
    value: function getOption(option, menuIndex) {
      var _this2 = this;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          mode = _this$props2.mode,
          keyword = _this$props2.keyword,
          value = _this$props2.value,
          activeValue = _this$props2.activeValue,
          hoveredValue = _this$props2.hoveredValue,
          expandTrigger = _this$props2.expandTrigger,
          expandIcon = _this$props2.expandIcon,
          loadingIcon = _this$props2.loadingIcon;
      var isMulti = mode === 'multiple';

      var optionValue = function () {
        var value = option[_this2.getFieldName('value')];

        return /*#__PURE__*/React.isValidElement(value) ? menuIndex : value;
      }();

      var optionKey = [].concat(_toConsumableArray(activeValue.slice(0, menuIndex)), [optionValue]);
      var hasChildren = option[this.getFieldName('children')] && option[this.getFieldName('children')].length > 0;
      var hasLeaf = hasChildren || option.isLeaf === false;
      var onSelect = this.props.onSelect.bind(this, option, menuIndex);
      var onMultiSelect = this.props.onMultiSelect.bind(this, option, menuIndex, optionKey);
      var onItemDoubleClick = this.props.onItemDoubleClick.bind(this, option, menuIndex);

      var handleClick = function handleClick(e) {
        isMulti && !hasLeaf ? undefined : onSelect(e);
      };

      var handleMultiClick = function handleMultiClick(e) {
        if (activeValue[menuIndex] === optionValue) {
          e.stopPropagation();
        }
      };

      var expandProps = {
        onClick: handleClick,
        onDoubleClick: onItemDoubleClick
      };
      var menuItemCls = "".concat(prefixCls, "-menu-item");

      if (isMulti) {
        menuItemCls += " ".concat(prefixCls, "-menu-item-multi");
      }

      var expandIconNode = null;

      if (hasLeaf) {
        menuItemCls += " ".concat(prefixCls, "-menu-item-expand");

        if (!option.loading) {
          expandIconNode = /*#__PURE__*/React.createElement("span", {
            className: "".concat(prefixCls, "-menu-item-expand-icon")
          }, expandIcon);
        }
      }

      if (expandTrigger === 'hover' && hasLeaf) {
        expandProps = {
          onMouseEnter: this.delayOnEvent.bind(this, onSelect),
          onMouseLeave: this.delayOnEvent.bind(this),
          onClick: handleClick
        };
      }

      if (this.isStatusOption(hoveredValue, option, menuIndex)) {
        menuItemCls += " ".concat(prefixCls, "-menu-item-hovered");
      }

      if (this.isStatusOption(activeValue, option, menuIndex)) {
        expandProps.ref = this.saveMenuItems(menuIndex);
      }

      if (!isMulti && this.isStatusOption(value, option, menuIndex)) {
        menuItemCls += " ".concat(prefixCls, "-menu-item-active");
      }

      if (option.disabled) {
        menuItemCls += " ".concat(prefixCls, "-menu-item-disabled");
      }

      var loadingIconNode = null;

      if (option.loading) {
        menuItemCls += " ".concat(prefixCls, "-menu-item-loading");
        loadingIconNode = loadingIcon || null;
      }

      var _ref = function () {
        if (!isMulti) {
          return {};
        }

        var checked;
        var indeterminate;

        if (keyword) {
          checked = isIncludeArray(value, optionValue);
        } else if (hasLeaf) {
          var children = option[_this2.getFieldName('children')];

          var getEnableValues = _this2.props.getEnableValues.bind(_this2);

          var childrenValue = getEnableValues(children);
          var selectedValue = map(value, function (valueItem) {
            return valueItem.slice(menuIndex + 1);
          });
          checked = every(childrenValue, function (valueItem) {
            return isIncludeArray(selectedValue, valueItem);
          });
          indeterminate = !checked && some(childrenValue, function (valueItem) {
            return isIncludeArray(selectedValue, valueItem);
          });
        } else {
          checked = some(value, function (valueItem) {
            return valueItem[menuIndex] === optionValue;
          });
        }

        return {
          checked: checked,
          indeterminate: indeterminate
        };
      }(),
          checked = _ref.checked,
          indeterminate = _ref.indeterminate;

      var label = option[this.getFieldName('label')];
      var labelContent = /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-menu-item-label")
      }, label);
      var menuItemProps = {
        key: optionKey,
        option: option,
        label: label,
        menuItemCls: menuItemCls,
        expandProps: expandProps,
        prefixCls: prefixCls,
        isMulti: isMulti,
        checked: checked,
        indeterminate: indeterminate,
        labelContent: labelContent,
        expandIconNode: expandIconNode,
        loadingIconNode: loadingIconNode,
        handleMultiClick: handleMultiClick,
        onMultiSelect: onMultiSelect,
        onMouseEnter: expandProps === null || expandProps === void 0 ? void 0 : expandProps.onMouseEnter
      };
      return /*#__PURE__*/React.createElement(MenuItem, menuItemProps);
    }
  }, {
    key: "getCheckAllOption",
    value: function getCheckAllOption(menuIndex) {
      var _this$props3 = this.props,
          mode = _this$props3.mode,
          prefixCls = _this$props3.prefixCls,
          value = _this$props3.value,
          enableValues = _this$props3.enableValues,
          _this$props3$withChec = _this$props3.withCheckAll,
          withCheckAll = _this$props3$withChec === void 0 ? true : _this$props3$withChec;
      var isMulti = mode === 'multiple';

      if (!(isMulti && menuIndex === 0) || !withCheckAll) {
        return null;
      }

      var checked = value.length >= enableValues.length && enableValues.every(function (valueItem) {
        return isIncludeArray(value, valueItem);
      });
      var indeterminate = !checked && value.length > 0;
      var onMultiSelectAll = this.props.onMultiSelectAll.bind(this);
      return /*#__PURE__*/React.createElement("li", {
        className: "".concat(prefixCls, "-menu-item ").concat(prefixCls, "-menu-item-multi ").concat(prefixCls, "-menu-item-multi-check-all"),
        role: "menuitem",
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-menu-item-content")
      }, /*#__PURE__*/React.createElement(Checkbox, {
        className: "".concat(prefixCls, "-menu-item-checkbox"),
        checked: checked,
        indeterminate: indeterminate,
        onChange: onMultiSelectAll
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-menu-item-label")
      }, "\u5168\u9009"))));
    }
  }, {
    key: "getActiveOptions",
    value: function getActiveOptions(values) {
      var _this3 = this;

      var options = this.props.options;
      var activeValue = values || this.props.activeValue;
      return arrayTreeFilter(options, function (o, level) {
        return o[_this3.getFieldName('value')] === activeValue[level];
      }, {
        childrenKeyName: this.getFieldName('children')
      });
    }
  }, {
    key: "getShowOptions",
    value: function getShowOptions() {
      var _this4 = this;

      var options = this.props.options;
      var result = this.getActiveOptions().map(function (activeOption) {
        return activeOption[_this4.getFieldName('children')];
      }).filter(function (activeOption) {
        return !isEmpty(activeOption);
      });
      result.unshift(options);
      return result;
    }
  }, {
    key: "delayOnEvent",
    value: function delayOnEvent(onEvent) {
      var _this5 = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.delayTimer) {
        clearTimeout(this.delayTimer);
        this.delayTimer = null;
      }

      if (typeof onEvent === 'function') {
        this.delayTimer = window.setTimeout(function () {
          onEvent.apply(void 0, args);
          _this5.delayTimer = null;
        }, 150);
      }
    }
  }, {
    key: "scrollActiveItemToView",
    value: function scrollActiveItemToView() {
      // scroll into view
      var optionsLength = this.getShowOptions().length; // eslint-disable-next-line no-plusplus

      for (var i = 0; i < optionsLength; i++) {
        var menuItem = this.menuItems[i];
        var menuItemParent = menuItem && menuItem.parentElement;

        if (menuItemParent) {
          var paddingTop = Number(getElementStyle(menuItemParent).paddingTop.replace('px', ''));
          menuItemParent.scrollTop = menuItem.offsetTop - paddingTop;
        }
      }
    }
  }, {
    key: "setMenuPosition",
    value: function setMenuPosition() {
      var _this6 = this;

      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      var menusEdgeBuffer = this.props.menusEdgeBuffer;
      var optionsLength = this.getShowOptions().length;

      if (Number(optionsLength) <= 0) {
        return;
      }

      var clientHeight = document.body.clientHeight;

      var _loop = function _loop(i) {
        // 1、计算left
        var prevMenusWidthSum = 0;

        for (var j = i - 1; j >= 0; j--) {
          // 子菜单间距为4px
          prevMenusWidthSum += _this6.menus[j].offsetWidth + 4;
        } // 2、计算top


        var currentMenu = _this6.menus[i];
        var prevMenu = _this6.menus[i - 1];
        var prevMenuPaddingTop = Number(getElementStyle(currentMenu).paddingTop.replace('px', ''));
        var prevMenuTop = Number(getElementStyle(prevMenu).top.replace('px', ''));
        var prevMenuItemsTopSum = prevMenuTop + _this6.menuItems[i - 1].offsetTop - prevMenu.scrollTop - prevMenuPaddingTop;

        var menuWrapTop = _this6.menuWrap.parentElement.getBoundingClientRect().top;

        var currentMenuHeight = currentMenu.offsetHeight;
        var currentMenuMaxTop = clientHeight - menuWrapTop - currentMenuHeight - menusEdgeBuffer;

        var currentMenuTop = function () {
          if (currentMenuMaxTop <= 0) {
            return 0;
          }

          return prevMenuItemsTopSum > currentMenuMaxTop ? currentMenuMaxTop : prevMenuItemsTopSum;
        }(); // 3、设置left和top


        currentMenu.style.left = prevMenusWidthSum + 'px';
        currentMenu.style.top = currentMenuTop + 'px';
      };

      for (var i = 1; i < optionsLength; i++) {
        _loop(i);
      }

      if (typeof callback === 'function') {
        callback();
      }
    }
  }, {
    key: "handleMenuScrollChange",
    value: function handleMenuScrollChange(menuScrollOpen) {
      this.setState({
        menuScrollOpen: menuScrollOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames,
          _this7 = this;

      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          transitionName = _this$props4.transitionName,
          visible = _this$props4.visible,
          dropdownMenuColumnStyle = _this$props4.dropdownMenuColumnStyle,
          size = _this$props4.size,
          mode = _this$props4.mode;
      var showOptions = this.getShowOptions();
      var isMulti = mode === 'multiple';
      var sizeCls = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-menu-lg"), size === 'large'), _defineProperty(_classnames, "".concat(prefixCls, "-menu-sm"), size === 'small'), _classnames));
      return /*#__PURE__*/React.createElement(CSSMotion, {
        visible: visible,
        motionName: transitionName,
        removeOnLeave: false,
        leavedClassName: "".concat(prefixCls, "-menu-wrap-hidden"),
        onAppearActive: this.onShowActive,
        onEnterActive: this.onShowActive,
        onLeaveEnd: this.onShowEnd
      }, function (_ref2) {
        var _classnames2;

        var className = _ref2.className,
            style = _ref2.style;
        var menuClas = classnames("".concat(prefixCls, "-menu"), (_classnames2 = {}, _defineProperty(_classnames2, "".concat(prefixCls, "-menu-multi"), isMulti), _defineProperty(_classnames2, sizeCls, sizeCls), _classnames2));
        return /*#__PURE__*/React.createElement("div", {
          ref: _this7.saveMenuWrap,
          className: className,
          style: _extends({
            position: 'relative'
          }, style)
        }, showOptions.map(function (options, menuIndex) {
          return /*#__PURE__*/React.createElement("ul", {
            className: menuClas,
            key: menuIndex,
            ref: _this7.saveMenus(menuIndex),
            style: dropdownMenuColumnStyle,
            onScroll: _this7.handleMenuScroll(menuIndex)
          }, _this7.getCheckAllOption(menuIndex), options.map(function (option) {
            return _this7.getOption(option, menuIndex);
          }));
        }));
      });
    }
  }]);

  return Menus;
}(React.Component);

Menus.defaultProps = {
  options: [],
  value: [],
  activeValue: [],
  onSelect: function onSelect() {},
  prefixCls: 'rc-cascader-menus',
  visible: false,
  expandTrigger: 'click',
  menusEdgeBuffer: 20
};
export default Menus;